<template>
  <b-row>
    <b-col cols="12">
      <company-content />
      <company-submitted-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CompanyContent from './CompanyContent.vue'
import CompanySubmittedContent from './CompanySubmittedContent.vue'

export default {
  components: {
    BRow,
    BCol,

    CompanyContent,
    CompanySubmittedContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>